import NamedDto from 'modules/base/dto/NamedDto';

export class Lummus2ModelAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.code = null;
		/** @type {string} */
		this.unitOpCode = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.title = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _Lummus2ModelAttributeEditDtoProps
	 * @property {string} type
	 * @property {string} value
	 * @property {string} code
	 * @property {string} unitOpCode
	 * @property {string} uom
	 * @property {title} title
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _Lummus2ModelAttributeEditDtoProps} Lummus2ModelAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {Lummus2ModelAttributeEditDtoProps} props
	 * @returns {Lummus2ModelAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.value = props.value;
		this.code = props.code;
		this.unitOpCode = props.unitOpCode;
		this.uom = props.uom;
		this.title = props.title;
		this.orderIndex = props.orderIndex;
		return this;
	}
}

export default Lummus2ModelAttributeEditDto;
